import React from 'react'
import Link from 'gatsby-link'
import img1 from '../images/multimedia/2019/160x600.jpg'
import img2 from '../images/multimedia/2019/300x250.jpg'
import img3 from '../images/multimedia/2019/468x60.jpg'
import img4 from '../images/multimedia/2019/728x90.jpg'

import img6 from '../images/multimedia/2019/general-1-1080x1080.jpg'
import img7 from '../images/multimedia/2019/general-2-1920x1080.jpg'
import img8 from '../images/multimedia/2019/general-3-2400x1256.jpg'

import img5 from '../images/multimedia/2019/discount-2400x1256.png'
import img9 from '../images/multimedia/2019/tracks-640x960.png'


const MultimediaItem = (props) => {
	return (
    <p>
        <h5>{ props.size }</h5>
        <img className="img-responsive"  src={props.image} />
    </p>
    	);
};


const PressRelease = (props) => {
	return (
    <p>
        <h5></h5>
        <a href={props.source} target="_blank" >{props.title}</a>
    </p>
    	);
};

const Multimedia = () => (
<section id="multimedia" className="parallax-section">
	<div className="container">
        <br /><br /><br /><br /><br />
		<div className="row">
			<div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
				<div className="team-wrapper">
                    <br /><br />
                    <div className="row">
                        <p>
                        <b>These are the multimedia materials that our partners are allowed to use for DevExperience 2019</b>
                        </p>
                    </div>
                    <div className="row">
                        <p>
                            <b>Press releases</b>
                        </p>
                        <p>
                            <div className="col-md-6">
                                <PressRelease source="../press-release/Comunicat-de-Presa-DevExperience-2019.pdf" title="Comunicat de presa in romana" />
                            </div>
                            <div className="col-md-6">
                                <PressRelease source="../press-release/Press-Release-DevExperience-2019.pdf" title="English Press Release" />
                            </div>
                        </p>
                    </div>   
                    <div className="row">
                        <p>
                            <div className="col-md-3">
                                <MultimediaItem size="728x90" image={img4} />
                            </div>
                            <div className="col-md-3">
                                <MultimediaItem size="468x60" image={img3} />
                            </div>
                            <div className="col-md-3">
                                <MultimediaItem size="300x250" image={img2} />
                            </div>
                            <div className="col-md-3">
                                <MultimediaItem size="160x600" image={img1} />
                                
                            </div>                            
                        </p>
                    </div>
                    <div className="row">
                        <p>
                            <div className="col-md-4">
                                <MultimediaItem size="2400x1256" image={img8} />
                            </div>
                            <div className="col-md-4">
                                <MultimediaItem size="1920x1080" image={img7} />
                            </div>
                            <div className="col-md-4">
                                <MultimediaItem size="1080x1080" image={img6} />
                            </div>
                        </p>
                    </div>
                    <div className="row">
                        <p>
                            <div className="col-md-6">
                                <MultimediaItem size="2400x1256" image={img5} />
                            </div>
                            <div className="col-md-6">
                                <MultimediaItem size="640x960" image={img9} />
                            </div>
                        </p>
                    </div>                    
                </div>
			</div>
        </div>
    </div>
</section>
)

export default Multimedia


// WEBPACK FOOTER //
// ./src/pages/multimedia.js